import React from 'react';
import { Carousel } from 'react-carousel-minimal';

export default function Certifications(props) {

  const data = [
    {
      image: process.env.PUBLIC_URL + 'Certifications/algotoolbox.png',
      caption: "Algorithm Toolbox"
    },
    {
      image: process.env.PUBLIC_URL + 'Certifications/gitgithub.png',
      caption: "Introduction to Git and GitHub"
    },
    {
      image: process.env.PUBLIC_URL + 'Certifications/kickstart2022.png',
      caption: "Google Kickstart"
    },
    {
      image: process.env.PUBLIC_URL + 'Certifications/goldmansachsfintech.png',
      caption: "Goldman Sachs Virtual Internship"
    },
    {
      image: process.env.PUBLIC_URL + 'Certifications/jpmorganchase.png',
      caption: "Jp Morgan Chase Virtual Internship"
    },
    {
      image: process.env.PUBLIC_URL + 'Certifications/codetech.png',
      caption: "State-Level C Programming Competition ( 2nd Winner )"
    },
    {
      image: process.env.PUBLIC_URL + 'Certifications/hackerrank.png',
      caption: "Problem Solvig (Basic)"
    },
    {
      image: process.env.PUBLIC_URL + 'Certifications/GSSoC2023badge.jpg',
      caption: "GSSoC 2023 Participant"
    }
  ];

  const captionStyle = {
    fontSize: '2em',
    fontWeight: 'bold',
  }
  const slideNumberStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
  }
    
  return (

    <div id='certifications' className='-z-50 md:pl-[350px] pl-14 pr-14 pt-16 pb-16 flex flex-col space-y-4 ' onMouseOver={() => props.onHover("certifications")}>
      
      <h1 className='text-3xl pt-2 font-[650] text-[#173b6c] '>Certifications</h1>
      
      <hr className='relative pb-4 w-12 border-t-4 border-blue-400' />

      <div className="App">
      <div style={{ textAlign: "center" }}>
        <div style={{
          padding: "0 20px"
        }}>
          <Carousel
            data={data}
            time={2000}
            width={`(window.innerWidth > 768 ? '850px' : '1100px')`}
            height="550px"
            captionStyle={captionStyle}
            radius="10px"
            slideNumber={true}
            slideNumberStyle={slideNumberStyle}
            captionPosition="bottom"
            automatic={true}
            dots={true}
            pauseIconColor="white"
            pauseIconSize="40px"
            slideBackgroundColor="darkgrey"
            slideImageFit="contain"
            thumbnails={true}
            thumbnailWidth="100px"
            style={{
              textAlign: "center",
              maxWidth: "850px",
              maxHeight: "500px",
              margin: "40px auto",
            }}
          />
        </div>
      </div>
    </div>
    
    </div>

  )
}
